import { render, staticRenderFns } from "./BackgroundColor.vue?vue&type=template&id=6ea7161f&scoped=true&"
import script from "./BackgroundColor.vue?vue&type=script&lang=js&"
export * from "./BackgroundColor.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundColor.vue?vue&type=style&index=0&id=6ea7161f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea7161f",
  null
  
)

export default component.exports